import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Join class names, letting later Tailwind utilities win over earlier ones.
 *
 * Lives here rather than in each app because the components below use it, and
 * two copies of the merge order is two ways for the same component to render
 * differently in two places.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
